module.exports = __webpack_public_path__ + "static/media/youtube_social_icon_red.fe8ee891.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/youtube/youtube_social_icon_red.png
// module id = 445
// module chunks = 0